import { BaseDto } from './base.dto';
import { BookingStatusDto } from './bookingStatus.dto';
import { BookingDto } from './booking.dto';
import { UserDto } from './user.dto';

export class BookingStatusHistoryDto extends BaseDto {
    note?: string;
    status: BookingStatusDto;
    booking: BookingDto;
    user: UserDto;
}
  